module.exports = __webpack_public_path__ + "img/icon-name.f90447cd.png";